import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { NotificationEntry } from '../../models'
import { NotificationStatusBadgeComponent } from './notification-status-badge.component'

@Component({
    selector: 'ach-notification-table',
    standalone: true,
    imports: [DatePipe, NotificationStatusBadgeComponent],
    templateUrl: './notification-table.component.html',
    styleUrl: './notification-table.component.scss',
})
export class NotificationTableComponent {
    @Input({ required: true }) notifications: NotificationEntry[] = []
    @Input() unavailable = false

    get sortedNotifications(): NotificationEntry[] {
        return [...this.notifications].sort((a, b) =>
            new Date(b.sentDateTime).getTime() - new Date(a.sentDateTime).getTime()
        )
    }
}
